import { LegalPage } from "../../components/LegalPage";

export function Aup() {
  return (
    <LegalPage
      title="Acceptable Use Policy"
      description="WeConsult Rx acceptable use policy: prohibited activities, content restrictions, and consequences for violations."
      path="/aup"
      effective="2026-05-30"
    >
      <p>
        This Acceptable Use Policy (“AUP”) applies to the WeConsult Rx
        platform. By using the Service you agree not to engage in any of the
        prohibited conduct below.
      </p>

      <h2>Prohibited conduct</h2>
      <h3>Legal violations</h3>
      <ul>
        <li>Violating any applicable law, including HIPAA, state pharmacy law, or controlled substances law.</li>
        <li>Infringing intellectual property or privacy rights of third parties.</li>
        <li>Uploading content that is defamatory, obscene, or that constitutes harassment.</li>
      </ul>

      <h3>Security violations</h3>
      <ul>
        <li>Attempting to gain unauthorized access to the Service, customer data, or supporting infrastructure.</li>
        <li>Probing, scanning, or testing vulnerabilities except under our <a href="/responsible-disclosure">responsible disclosure program</a>.</li>
        <li>Distributing malware, conducting denial-of-service attacks, or interfering with availability.</li>
        <li>Circumventing rate limits or quotas.</li>
      </ul>

      <h3>Platform abuse</h3>
      <ul>
        <li>Using the platform to send unsolicited marketing communications (spam).</li>
        <li>Reselling or sublicensing the Service without written permission.</li>
        <li>Reverse-engineering the Service except as expressly permitted by law.</li>
        <li>Using the Service to develop a competing product.</li>
      </ul>

      <h3>Data misuse</h3>
      <ul>
        <li>Processing PHI without an executed Business Associate Agreement.</li>
        <li>Re-identifying de-identified data sets.</li>
        <li>Sharing user credentials.</li>
      </ul>

      <h2>Enforcement</h2>
      <p>
        We may suspend or terminate access for AUP violations. Where possible
        we will notify you and provide an opportunity to cure. Imminent harm or
        legal mandates may require immediate suspension without notice.
      </p>

      <h2>Reporting violations</h2>
      <p>
        Email abuse@weconsultrx.com. For security issues, see{" "}
        <a href="/responsible-disclosure">/responsible-disclosure</a>.
      </p>
    </LegalPage>
  );
}
